const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Logistics = 'Logistics'
const Clerk = 'Clerk'
const Supervisor = 'Supervisor'
const Seller = 'Seller'
const SalesExecutive = 'SalesExecutive'

export default [
  {
    path: '/order/create',
    name: 'CreateOrder',
    component: () => import('@/components/create_order/CreateOrder.vue'),
    meta: {
      auth: true,
      roles: [Manager, Director, Logistics, Analyst, Clerk, Supervisor, Seller, SalesExecutive ],
    },
  },

]